import React from "react";
import { ArrowRight, ArrowDown } from "lucide-react";
import { SIGNAL_STEPS } from "../../data/content";

const toneMap = {
  neutral: "border-white/12 bg-white/[0.03] text-muted-foreground",
  brand: "border-primary/40 bg-primary/[0.08] text-foreground",
  action: "border-signal-amber/40 bg-signal-amber/[0.08] text-foreground",
};

export default function SignalPath({ compact = false }) {
  return (
    <div className="rounded-lg border border-white/10 bg-navy-900/60 p-5 sm:p-7">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-primary">
          The control &amp; evidence path
        </p>
        <span className="text-xs text-muted-foreground">Illustrative signal flow</span>
      </div>

      {/* Desktop: horizontal */}
      <div className="mt-5 hidden lg:flex items-stretch gap-2">
        {SIGNAL_STEPS.map((s, i) => (
          <React.Fragment key={s.key}>
            <div className={`flex-1 rounded-xl border px-3.5 py-3.5 ${toneMap[s.tone]}`}>
              <p className="text-[0.82rem] font-semibold leading-snug text-foreground">{s.label}</p>
              <p className="mt-1 text-[0.72rem] text-muted-foreground leading-snug">{s.sub}</p>
            </div>
            {i < SIGNAL_STEPS.length - 1 && (
              <div className="flex items-center text-primary/70 shrink-0">
                <ArrowRight className="h-4 w-4" />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Mobile / tablet: vertical */}
      <div className="mt-5 lg:hidden space-y-2">
        {SIGNAL_STEPS.map((s, i) => (
          <React.Fragment key={s.key}>
            <div className={`rounded-xl border px-4 py-3 ${toneMap[s.tone]}`}>
              <p className="text-sm font-semibold text-foreground">{s.label}</p>
              <p className="mt-0.5 text-xs text-muted-foreground">{s.sub}</p>
            </div>
            {i < SIGNAL_STEPS.length - 1 && (
              <div className="flex justify-center text-primary/70">
                <ArrowDown className="h-4 w-4" />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>

      {!compact && (
        <p className="mt-5 text-sm text-muted-foreground">
          The downstream model is <span className="text-foreground font-medium">not part of norse3</span>. We inspect
          inbound prompts and outbound responses around it — we do not replace it.
        </p>
      )}
    </div>
  );
}
